import React from 'react';
import axios from 'axios';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import { useNotifications } from './Context/NotificationsCountContext';

import SendFeedbackModal from './Feedback/SendFeedbackModal';
import Profile from './Profile';
import SettingsModal from './Settings';

import styles from '../styles/Header.module.css';

import Logo from './Logo';

import IconContainer from '../Components/IconContainer';
import { ReactComponent as XIcon } from '../icons/x-close.svg';

const Header = () => {
    const location = useLocation();
    const navigate = useNavigate();

    const [isProfileModal, setIsProfileModal] = React.useState(false);
    const [isSettingsModal, setIsSettingsModal] = React.useState(false);
    const [isSendFeedbackModal, setIsSendFeedbackModal] = React.useState(false);

    const [isMobileMenuOpen, setIsMobileMenuOpen] = React.useState(false);

    const { countOfUnreadNotifications } = useNotifications();

    const [importantAccountData, setImportantAccountData] = React.useState([]);
    const [loading, setLoading] = React.useState(true);

    const handleLogout = () => {
        localStorage.removeItem('token');
        window.location.href = '/';
    };

    React.useEffect(() => {
        const token = localStorage.getItem('token');
        if (!token) {
            handleLogout();
            return;
        }

        axios.get('/api/get-essential-account-data', {
            headers: { 
                Authorization: `Bearer ${token}` 
            }
        })
        .then((response) => {
            const data = response.data;

            const missingParams = Object.keys(data).filter(key => !data[key]);

            if (missingParams.length > 0) {
                navigate(`/essential-data`);
            }
        })
        .catch((error) => {
            console.error('Ошибка при получении данных пользователя:', error);
            handleLogout();
            navigate('/');
        })
        .finally(() => {
            setLoading(false);
        });
    }, []);

    React.useEffect(() => {
        const token = localStorage.getItem('token');
        if (!token) handleLogout();

        axios.get('/api/get-important-account-data', {
            headers: {
                Authorization: `Bearer ${token}`,
            }
        }).then((response) => {
            setImportantAccountData(response.data);
        }).catch((error) => {
            console.error('Ошибка при получении данных пользователя:', error);
        }).finally(() => {
            setLoading(false);
        });
    }, []);

    React.useEffect(() => {
        setIsMobileMenuOpen(false);
    }, [location]);

    const toggleMobileMenu = () => {
        setIsMobileMenuOpen(!isMobileMenuOpen);
    };
    React.useEffect(() => {
        const handleResize = () => {
        if (window.innerWidth > 1020) {
            setIsMobileMenuOpen(false);
        }
        };

        handleResize();

        window.addEventListener('resize', handleResize);
        return () => window.removeEventListener('resize', handleResize);
    }, [setIsMobileMenuOpen]);
    
    React.useEffect(() => {
        if (window.location.hash === '#settings') {
            setIsSettingsModal(true);
        }
    }, []);

    return (
        <>
            {isProfileModal && <Profile closeModal={() => setIsProfileModal(false)} fiodata={importantAccountData} />}
            {isSendFeedbackModal && <SendFeedbackModal closeModal={() => setIsSendFeedbackModal(false)} />}
            {isSettingsModal && <SettingsModal closeModal={() => {window.location.hash = ''; setIsSettingsModal(false)}} />}

            <div className={`${styles.header} ${isMobileMenuOpen && styles.headerOpen}`}>
                <div className={styles.headerMenu}>
                    <div style={{margin: '0 15px', display: 'flex', justifyContent: 'space-between', alignItems: 'center'}}>
                        <Logo to='/home' position='relative' />
                        {isMobileMenuOpen && <IconContainer Icon={XIcon} onClick={toggleMobileMenu} size = '20' color = 'black' className = '' />}
                    </div>
                    <ul style={{marginTop: '40px'}}>
                        <li>
                            <Link className={`${styles.navButton} ${location.pathname === '/account' ? styles.active : ''}`} style={{flexDirection: 'column', alignItems: 'start'}} to={'/account'}>
                                <span className={styles.defaultText}>{loading ? <>Загрузка...</> : <>{importantAccountData && importantAccountData.lastname ? `${importantAccountData.lastname} ${importantAccountData.firstname} ${importantAccountData.surname}` : 'Анкета'}</>}</span>
                                <span className={styles.hoverText} style={{color: 'rgb(139 139 139)', fontWeight: '400'}}>Перейти к анкете</span>
                            </Link>
                        </li>
                        {importantAccountData.role === 'Арбитражный управляющий' && 
                        <>
                            <li><Link className={`${styles.navButton} ${location.pathname === '/home' ? styles.active : ''}`} to={'/home'}>
                                <img src='/img/icons/outline/house-2.svg' alt='-' />
                                Главная
                            </Link></li>
                            <li><Link className={`${styles.navButton} ${location.pathname === '/membership-fees' ? styles.active : ''}`} to={'/membership-fees'}>
                                <img src='/img/icons/navigationIcons/invoice.svg' alt='-' />
                                Членские взносы
                            </Link></li>
                            <li><Link className={`${styles.navButton} ${location.pathname === '/procedures' ? styles.active : ''}`} to={'/procedures'}>
                                <img src='/img/icons/navigationIcons/list.svg' alt='-' />
                                Процедуры
                            </Link></li>
                            <li><Link className={`${styles.navButton} ${location.pathname === '/applications' ? styles.active : ''}`} to={'/applications'}>
                                <img src='/img/icons/navigationIcons/chat-info.svg' alt='-' />
                                Мои заявки
                            </Link></li>
                            <li><Link className={`${styles.navButton} ${location.pathname === '/proposed-cases' ? styles.active : ''}`} to={'/proposed-cases'}>
                                <img src='/img/icons/navigationIcons/label.svg' alt='-' />
                                Витрина заявок
                            </Link></li>
                            <li><Link className={`${styles.navButton} ${location.pathname === '/inbox' ? styles.active : ''}`} to={'/inbox'}>
                                <img src='/img/icons/navigationIcons/inbox.svg' alt='-' />
                                Уведомления
                                &nbsp;
                                {countOfUnreadNotifications > 0 && <span className='notificationPill'>{countOfUnreadNotifications}</span>}
                            </Link></li>
                        </>}
                        {importantAccountData.role === 'АппаратСРО' && 
                        <>
                            <li><Link className={`${styles.navButton} ${location.pathname === '/home' ? styles.active : ''}`} to={'/home'}>
                                <img src='/img/icons/navigationIcons/home.svg' alt='-' />
                                Главная
                            </Link></li>
                            <li><Link className={`${styles.navButton} ${location.pathname === '/membership-fees' ? styles.active : ''}`} to={'/membership-fees'}>
                                <img src='/img/icons/navigationIcons/invoice.svg' alt='-' />
                                Членские взносы
                            </Link></li>
                            <li><Link className={`${styles.navButton} ${location.pathname === '/procedures' ? styles.active : ''}`} to={'/procedures'}>
                                <img src='/img/icons/navigationIcons/list.svg' alt='-' />
                                Процедуры
                            </Link></li>
                            <li><Link className={`${styles.navButton} ${location.pathname === '/proposed-cases' ? styles.active : ''}`} to={'/proposed-cases'}>
                                <img src='/img/icons/navigationIcons/label.svg' alt='-' />
                                Витрина заявок
                            </Link></li>
                            <li><Link className={`${styles.navButton} ${location.pathname === '/inbox' ? styles.active : ''}`} to={'/inbox'}>
                                <img src='/img/icons/navigationIcons/inbox.svg' alt='-' />
                                Уведомления
                                &nbsp;
                                {countOfUnreadNotifications > 0 && <span className='notificationPill'>{countOfUnreadNotifications}</span>}
                            </Link></li>
                            <li><Link className={`${styles.navButton} ${location.pathname === '/last-cases-messages' ? styles.active : ''}`} to={'/last-cases-messages'}>
                                <img src='/img/icons/navigationIcons/chat-info.svg' alt='-' />
                                Последние сообщения
                            </Link></li>
                            <li><Link className={`${styles.navButton} ${location.pathname === '/registers' ? styles.active : ''}`} to={'/registers'}>
                                <img src='/img/icons/navigationIcons/browser.svg' alt='-' />
                                Реестр должников и заявителей
                            </Link></li>
                            <li><Link className={`${styles.navButton} ${location.pathname === '/users' ? styles.active : ''}`} to={'/users'}>
                                <img src='/img/icons/navigationIcons/users-alt.svg' alt='-' />
                                Реестр членов СРО
                            </Link></li>
                        </>}
                    </ul>
                </div>
                <div className={styles.headerMenu}>
                    <ul>
                        <li><a className={styles.navButton} onClick={() => {navigate('/help')}}>
                            <img src='/img/icons/question.svg' alt='-' />
                            Как использовать ЛК
                        </a></li>
                        <li><a className={styles.navButton} onClick={() => {window.location.hash = 'settings'; setIsSettingsModal(true)}}>
                            <img src='/img/icons/navigationIcons/setting.svg' alt='-' />
                            Настройки
                        </a></li>
                        <li><a className={styles.navButton} onClick={() => {setIsSendFeedbackModal(true)}}>
                            Обратиться в поддержку
                        </a></li>
                        <li><a className={styles.navButton} onClick={() => {setIsProfileModal(true)}}>
                            Учётная запись
                        </a></li>
                    </ul>
                </div>
            </div>

            {!isMobileMenuOpen && 
            <div className={styles.openMenuButtonMobile} onClick={toggleMobileMenu}>
                Открыть меню
            </div>}
        </>
    )
}

export default Header;